import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddDepartment = createAsyncThunk(
  "other/AddDepartment",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/department-create/`, data)
    return response.data
  }
); 

export const UpdateDepartment = createAsyncThunk(
  "other/UpdateDepartment",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/department-update/${data.id}/`, data)
    return response.data
  }
);

export const GetDepartmentList = createAsyncThunk(
  "user/GetDepartmentList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/department-list/`)
    return data
  }
);

export const DeleteDepartment = createAsyncThunk(
  "other/DeleteDepartment",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/department-delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

